import { render, staticRenderFns } from "./IssueOfficialReceiptModal.vue?vue&type=template&id=6582b554&scoped=true&"
import script from "./IssueOfficialReceiptModal.vue?vue&type=script&lang=js&"
export * from "./IssueOfficialReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueOfficialReceiptModal.vue?vue&type=style&index=0&id=6582b554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582b554",
  null
  
)

export default component.exports